import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { IUserLogin } from '@auth/login/data/login.model';
import { SessionFacade } from '@shared/store/session.facade';
import Keycloak from 'keycloak-js';
import { isEmpty } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AccessGuardLogged {
  private readonly sessionFacade = inject(SessionFacade);
  private readonly keycloak = inject(Keycloak);

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.checkLoginInStore(state);
  }

  private checkLoginInStore(state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.sessionFacade.userLogin$.pipe(
      take(1),
      switchMap((userLogin: IUserLogin) => {
        const isAuthRoute = state.url.split('/').includes('auth');

        if (isAuthRoute) {
          return of(true);
        }

        if (!isEmpty(userLogin) || this.keycloak.authenticated) {
          return of(true);
        }

        return this.redirectToAuthPage(state);
      }),
      catchError(() => {
        return this.redirectToAuthPage(state);
      })
    );
  }

  private redirectToAuthPage(state: RouterStateSnapshot): Observable<boolean> {
    this.sessionFacade.saveUnauthNavigatedPageToStore(state.url);
    this.keycloak.login({ redirectUri: window.location.origin + state.url });
    return of(false);
  }
}
